<!--字典维护-->
<template>
    <div style="margin-bottom: 60px">
        <van-nav-bar :title="title" />
        <van-cell >
            <van-tree-select
                    height = 400
                    :items="items"
                    :active-id.sync="formModel.details"
                    :main-active-index.sync="activeIndex"
            >
                <template #content>
                    <!--                    <van-row>{{items[activeIndex].children}}</van-row>-->
                    <van-swipe-cell v-for="(item,i) in items[activeIndex].children" :key="item.id">
                        <van-cell-group>
                            <van-row type="flex" justify="space-between">
                                <van-col span="16">
                                    <van-cell :value="item.attrName">
                                        <!-- 使用 title 插槽来自定义标题 -->
                                        <template #icon>
                                            <van-icon v-if="getStatusIcon(item.statusCd)" name="passed" color="#00CD66" size="20" style="margin-top: 2px"/>
                                            <van-icon v-if="!getStatusIcon(item.statusCd)" name="pause-circle-o" color="#969799" size="20" style="margin-top: 2px"/>
                                        </template>
                                    </van-cell>
                                </van-col>
                                <van-col span="8">
                                <span style="float:right;margin-top: 5px">

                                    <van-button v-if="getStatusIcon(item.statusCd)" @click="backTop(item.parAttrId,item.attrId)" icon="back-top" plain type="info" size="small"/>
                                    <van-button v-if="!getStatusIcon(item.statusCd)" @click="reversalStatus(item.parAttrId,item.attrId,item.statusCd)" icon="play-circle-o" plain type="primary" size="small"/>
                                    <van-button v-if="getStatusIcon(item.statusCd)" @click="reversalStatus(item.parAttrId,item.attrId,item.statusCd)" icon="stop-circle-o" plain type="danger" size="small"/>
                                </span>
                                </van-col>
                            </van-row>
                        </van-cell-group>

                        <template #right v-if="getStatusIcon(item.statusCd)">
                            <van-button style="margin-top: 5.5px" @click="backDown(i)" icon="arrow-down" plain type="info" size="small"/>
                        </template>
                    </van-swipe-cell>

                </template>
            </van-tree-select>
        </van-cell>
        <van-cell>
            <span style="float:right;">
                <van-button  icon="plus" plain type="warning" size="small" @click="openPlus()"/>
            </span>
        </van-cell>
        <van-dialog v-model="show" title="明细录入" show-cancel-button :before-close="beforeClose">
            <van-cell-group>
                <van-field v-model="detailValue" maxlength="6" required :label="sortName"
                           placeholder="请输入新增的明细"
                           :error-message="errorMessage"
                           @focus="errorMessage=''"/>
            </van-cell-group>
        </van-dialog>
        <van-overlay :show="isStatusLoading">
            <div class="wrapper" @click.stop>
                <div class="block" />
            </div>
        </van-overlay>
    </div>

</template>

<script>
    import * as MyApi from '@/api/URLApiAddr.js'
    import * as BusiConsts from '../../common/BusiConsts.js'

    export default {
        name: "SortPage",
        data() {
            return {
                title: '字典维护',
                items: [],
                formModel: {
                    details: []
                },
                activeIndex: 0,
                show: false,
                detailValue: '',
                errorMessage: '',
                sortName:''

            }
        },
        mounted() {
            this.initSorts()
        },
        methods: {
            initSorts(){
                this.$axios.get(MyApi.QRY_ATTR_ALL_LIST).then((resp) => {
                    if(resp.code == '200'){
                        let data = resp.data;
                        this.items = data.sort
                    }else{
                        this.$toast.fail("数据初始化异常");
                    }

                }).catch((error) => {
                    console.log(error)
                    this.$toast.fail("数据初始化异常");
                })

            },
            getStatusIcon(statusCd){
                if(BusiConsts.STATUS_CD_1000 == statusCd){
                    return true
                }else{
                    return false
                }
            },
            openPlus(){
                this.sortName = this.items[this.activeIndex].text
                this.show = true
            },
            beforeClose(action, done) {
                if("confirm" === action){
                    //console.log()

                    if(this.detailValue.length <= 0
                        || this.detailValue.length > 6){
                        this.errorMessage = "明细长度不能大于6位"
                        done(false)
                    }else{
                        let parAttrId = this.items[this.activeIndex].attrId;
                        let params = {
                            parAttrId : parAttrId,
                            attrName: this.detailValue
                        }
                        this.$axios.post(MyApi.SAVE_SORT_DETAIL,params/*,options*/)
                            .then((response) =>  {
                                debugger
                                let code = response.code;
                                if(code == '200'){
                                    this.initSorts()
                                    this.$toast.success(response.msg);
                                    done()
                                }else{
                                    done(false)
                                    //this.errorMessage = response.msg
                                }
                            })
                            .catch((err) =>{
                                console.log(err)
                            })

                    }
                }else{
                    done();
                }
            },
            reversalStatus(parAttrId,attrId,statusCd){
                this.$toast.loading({
                    duration: 0, // 持续展示 toast
                    forbidClick: true,
                    message: '修改中',
                });
                let params = {
                    parAttrId: parAttrId,
                    attrId: attrId,
                    statusCd: statusCd
                }
                this.$axios.post(MyApi.REVERSAL_STATUS,params/*,options*/)
                    .then((response) =>  {
                        let code = response.code;
                        if(code == '200'){
                            this.initSorts()
                            this.$toast.success(response.msg);
                        }else{
                            this.$toast.fail(response.msg)
                        }
                    })
                    .catch((err) =>{
                        console.log(err)
                        this.$toast.fail("翻转状态异常")
                    })

            },
            backTop(parAttrId,attrId){
                this.$toast.loading({
                    duration: 0, // 持续展示 toast
                    forbidClick: true,
                    message: '修改中',
                });
                let params = {
                    parAttrId: parAttrId,
                    attrId: attrId
                }
                this.$axios.post(MyApi.BACK_TOP,params/*,options*/)
                    .then((response) =>  {
                        let code = response.code;
                        if(code == '200'){
                            this.initSorts()
                            this.$toast.success(response.msg);
                        }else{
                            this.$toast.fail(response.msg)
                        }
                    })
                    .catch((err) =>{
                        console.log(err)
                        this.$toast.fail("置顶异常")
                    })

            },
            backDown(index){
                let detail = this.items[this.activeIndex].children[index];
                let detailNext = this.items[this.activeIndex].children[index+1];
                //如果下一个节点不生效,不用置换
                if(BusiConsts.STATUS_CD_1000 != detailNext.statusCd){
                    this.$toast.fail(detailNext.attrName + '-不生效,不需要置换')
                }
                debugger;
                //传递参数时就直接置换
                let params = [
                    {attrId:detail.attrId,orderFlag: detail.orderFlag+1},
                    {attrId:detailNext.attrId,orderFlag: detailNext.orderFlag-1}
                ]
                this.$axios.post(MyApi.BACK_DOWN,params/*,options*/)
                    .then((response) =>  {
                        let code = response.code;
                        if(code == '200'){
                            this.initSorts()
                            this.$toast.success(response.msg);
                        }else{
                            this.$toast.fail(response.msg)
                        }
                    })
                    .catch((err) =>{
                        console.log(err)
                        this.$toast.fail("置换异常")
                    })



            }
        }
    }
</script>

<style scoped>

</style>
